export const ADMIN_ACTIVITY_USER_ID = '00000000-0000-0000-0000-000000000002';
